var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIhoten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.83333C6.2535 1.83333 4.8335 3.25333 4.8335 4.99999C4.8335 6.71333 6.1735 8.09999 7.92016 8.15999C7.9735 8.15333 8.02683 8.15333 8.06683 8.15999C8.08016 8.15999 8.08683 8.15999 8.10016 8.15999C8.10683 8.15999 8.10683 8.15999 8.1135 8.15999C9.82016 8.09999 11.1602 6.71333 11.1668 4.99999C11.1668 3.25333 9.74683 1.83333 8.00016 1.83333Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3866 9.93333C9.52664 8.69333 6.49331 8.69333 4.61997 9.93333C3.77331 10.5 3.30664 11.2667 3.30664 12.0867C3.30664 12.9067 3.77331 13.6667 4.61331 14.2267C5.54664 14.8533 6.77331 15.1667 7.99997 15.1667C9.22664 15.1667 10.4533 14.8533 11.3866 14.2267C12.2266 13.66 12.6933 12.9 12.6933 12.0733C12.6866 11.2533 12.2266 10.4933 11.3866 9.93333Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIhoten);
export default __webpack_public_path__ + "static/media/ihoten.69eca821fb588cf7dd9b92b32c792cb2.svg";
export { ForwardRef as ReactComponent };